// @gs/feedback/client — firstUnseenMessageId : position du separateur
// « Nouveaux messages » (CHORE-FBK-INBOX-V2, pattern Slack). Helper PUR
// (teste sans DOM, pattern filterTickets).
//
// Le separateur se place AVANT le premier message posterieur au marqueur
// « lu jusqu'a » du lecteur (fbk.Reads.last_seen_at, snapshot a l'ouverture —
// AVANT que l'ouverture ne marque lu). lastSeenAt null = jamais lu / non-lu
// manuel -> premier message des autres. Les messages du lecteur lui-meme et
// les messages supprimes (stub masque) ne declenchent jamais le separateur —
// meme doctrine que unread_count.

export interface UnseenCandidate {
  id: string;
  /** ISO (MessageDto.createdAt). */
  createdAt: string;
  authorUserId: string;
  deletedAt: string | null;
}

export function firstUnseenMessageId(
  messages: readonly UnseenCandidate[],
  lastSeenAt: string | null,
  currentUserId: string,
): string | null {
  const boundary = lastSeenAt ? Date.parse(lastSeenAt) : Number.NEGATIVE_INFINITY;
  if (Number.isNaN(boundary)) return null; // marqueur illisible : pas de separateur plutot qu'un faux
  const me = currentUserId.toLowerCase();
  let first: UnseenCandidate | null = null;
  for (const m of messages) {
    if (m.deletedAt) continue;
    if (m.authorUserId.toLowerCase() === me) continue;
    const at = Date.parse(m.createdAt);
    if (Number.isNaN(at) || at <= boundary) continue;
    if (!first || at < Date.parse(first.createdAt)) first = m;
  }
  return first?.id ?? null;
}
